import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { currentRating: String }

  connect() {
    // Set initial active state based on current rating
    this.updateActiveStates()
  }

  toggle(event) {
    event.preventDefault()

    const clickedRating = event.currentTarget.dataset.starFilterRatingParam
    const currentRating = this.currentRatingValue

    // If clicking the same rating that's already active, clear the filter
    // Otherwise, set the new rating filter
    let newUrl
    if (currentRating === clickedRating) {
      // Clear filter - go to base URL without rating parameter
      newUrl = new URL(window.location.href)
      newUrl.searchParams.delete('rating')
    } else {
      // Set new filter
      newUrl = new URL(window.location.href)
      newUrl.searchParams.set('rating', clickedRating)
    }

    // Navigate using Turbo
    Turbo.visit(newUrl.toString())
  }

  updateActiveStates() {
    // Remove all active classes
    this.element.querySelectorAll('.stars__filter').forEach(filter => {
      filter.classList.remove('stars__filter--active')
    })

    // Add active class to current rating if one is set
    if (this.currentRatingValue) {
      const activeFilter = this.element.querySelector(`[data-star-filter-rating-param="${this.currentRatingValue}"]`)
      if (activeFilter) {
        activeFilter.classList.add('stars__filter--active')
      }
    }
  }
}
